<template>
  <div>
    <div class="d-flex justify-content-end mb-3">
      <button
          type="button"
          class="btn btn-success"
          :disabled="!hasChanges"
          @click="saveChanges"
      >
        Сохранить
      </button>
    </div>
    <table class="table">
      <thead>
      <tr>
        <th scope="col">ID</th>
        <th scope="col">Проект</th>
        <th scope="col">Логирование</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(row, index) in tgChannel?.projects || []" :key="index">
        <th scope="row">{{ row.id }}</th>
        <td>{{ row.name }}</td>
        <td>
          <div class="form-check form-switch">
            <input
                class="form-check-input"
                type="checkbox"
                :id="`flexSwitchCheckDefault-${row.id}`"
                v-model="selectedProjects"
                :value="row.id"
            >
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import { computed, defineProps, ref, watch } from "vue";
import { useTgChannelsStore } from '@/store/tg-channels'

const props = defineProps({
  id: String,
})

const tgChannelsStore = useTgChannelsStore()
const selectedProjects = ref([])
const originalSelectedProjects = ref([])

const tgChannel = computed(() => tgChannelsStore.item)

// Инициализируем выбранные проекты когда загрузится канал
watch(tgChannel, (newVal) => {
  if (newVal?.projects) {
    const attachedProjectIds = newVal.projects
        .filter(project => project.isAttached)
        .map(project => project.id)

    selectedProjects.value = [...attachedProjectIds]
    originalSelectedProjects.value = [...attachedProjectIds]
  }
})

// Проверяем есть ли изменения
const hasChanges = computed(() => {
  if (selectedProjects.value.length !== originalSelectedProjects.value.length) {
    return true
  }

  // Сравниваем массивы (без учета порядка)
  return !selectedProjects.value.every(projectId =>
      originalSelectedProjects.value.includes(projectId)
  )
})

const saveChanges = async () => {
  if (!hasChanges.value) return

  try {
    await tgChannelsStore.update(props.id, {
      projectIds: selectedProjects.value
    })

    // Обновляем оригинальные значения после успешного сохранения
    originalSelectedProjects.value = [...selectedProjects.value]

    // Перезагружаем данные
    await tgChannelsStore.getById(props.id)

    alert('Изменения сохранены успешно!')
  } catch (error) {
    console.error('Ошибка при сохранении:', error)
    alert('Ошибка при сохранении изменений')
  }
}

// Загружаем данные
tgChannelsStore.getById(props.id)
</script>